import { ProjectType } from '@lopo-tech/lopo-api'
import React from 'react'
import { ProjectMilestonesPage } from 'src/pages/project_milestones'

const InfrastructureProjectMilestonesPage: React.FC = () => (
  <ProjectMilestonesPage projectType={ProjectType.InfrastructureProject} />
)

export default InfrastructureProjectMilestonesPage
